// reuseable state selectors for coordinator groups

const getCoordinatorGroupsForNetwork = ({ state, network }) => {
  const networkGroups = state.coordinatorGroups[network];
  return networkGroups && networkGroups.groups ? networkGroups.groups : [];
};

const getCoordinatorGroupByName = ({
  state,
  groupName,
  network,
}) => {
  const groups = getCoordinatorGroupsForNetwork({ state, network });
  return groups ? groups.find((group) => group.name === groupName) : null;
};

export {
  getCoordinatorGroupsForNetwork,
  getCoordinatorGroupByName,
};
